import {Component, createRef, RefObject} from "react";
import autoAnimate from "@formkit/auto-animate";
import ArrowDown from "./ArrowDown";

export default class Drawer extends Component<{title: string; content: string}, {isOpen: boolean}> {
    private drawerRef: RefObject<any> = createRef();

    state = {
        isOpen: false
    }

    componentDidMount() {
        autoAnimate(this.drawerRef.current!)
    }

    toggleDrawer = () => {
        this.setState({isOpen: !this.state.isOpen});
    }

    render() {
        return(
            <div className={'drawer'} data-open={this.state.isOpen} ref={this.drawerRef}>
                <button onClick={this.toggleDrawer}>{this.props.title} <ArrowDown /></button>
                {this.state.isOpen && <p dangerouslySetInnerHTML={{__html: this.props.content}} />}
            </div>
        );
    }
}